import PlatformProducts from './PlatformProducts'

export default PlatformProducts